/**
 * @generated SignedSource<<3d77bbe16fce2bffbf1fa62161cfc271>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowWithDragAndDrop_issueOld$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_old">;
  readonly " $fragmentType": "RowWithDragAndDrop_issueOld";
};
export type RowWithDragAndDrop_issueOld$key = {
  readonly " $data"?: RowWithDragAndDrop_issueOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowWithDragAndDrop_issueOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowWithDragAndDrop_issueOld",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isLinkRelationshipFieldEnabled",
          "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RowInner_old"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "c34cc38ebea4ad37aac9945fdfcf9eb1";

export default node;
